var $ = require('jquery');
var _ = require('underscore');
var Backbone = require('backbone');
var Handlebars = require('hbsfy/runtime');
var setupAllHandlebarsHelpers = require('./frontendHandlebarsHelpers');
var validationUtils = require('./utils/validationUtils');
var TorsoFormView = require('backbone-torso/modules/FormView');
var TorsoValidation = require('backbone-torso/modules/validation');
var TorsoCollection = require('backbone-torso/modules/Collection');
var applicationUtils = require('./applicationUtils');
var urls = require('./urls');
var sessionStorageService = require('./storage/sessionStorageService');
var routerUtils = require('./utils/routerUtils');
var userService = require('./user/userService');

var SERIAL_NUMBER_PROPERTY_NAME = sessionStorageService.SESSION_STORAGE_KEYS.serialNumber;

var ONSITE_VIEWS = {
  EXPRESS_CHECKIN_VIEW: 'expressCheckin',
  QUEUED_VIEW: 'queued'
};

require('./i18n/i18nInit');

Backbone.$ = $;
window.jQuery = $;
window.$ = $;

// Capture any ajax responses and process them
$.ajaxSetup({
  statusCode: {
    401: function(){
      // Redirect the to the login page.
      userService.isAuthenticated()
        .then(function() {
          // user is authenticated - redirect to logout.
          window.location = applicationUtils.currentApplication.logoutUrl;
        }, function() {
          // user is not authenticated - only redirect if the user isn't already on the login page.
          if (window.location.pathname !== applicationUtils.currentApplication.fullUrlPath) {
            window.location = applicationUtils.currentApplication.fullUrlPath;
          }
        });
    }
  }
});

$.fn.extend({
  propAttr: $.fn.prop || $.fn.attr
});

// Set default select2 theme to brec.
require('select2')(window, $);
$.fn.select2.defaults.set('theme', 'brec');

window.moment = require('moment');

_.extend(TorsoCollection.prototype, {fetchHttpAction: 'POST'});

// Attach handlebars helpers to Handlebars object
setupAllHandlebarsHelpers(Handlebars);

// Add custom formatters and validation
validationUtils.addCustomValidation(TorsoValidation);
validationUtils.addFormViewFormatters(TorsoFormView);

var asideView = require('./aside/asideView');
var AppointmentDetailsPerspective = require('./appointment/AppointmentDetailsPerspective');
var MultiAppointmentConfirmationPerspective = require('./appointment/MultiAppointmentConfirmationPerspective');
var AppointmentBillPerspective = require('./appointment-bill/AppointmentBillPerspective');
var AppointmentInsurancePerspective = require('./appointment-insurance/AppointmentInsurancePerspective');
var AppointmentTabsPerspective = require('./appointment/AppointmentTabsPerspective');
var AppointmentTabsView = require('./appointment/AppointmentTabsView');
var AppointmentQuestionnairePerspective = require('./appointment-questionnaire/AppointmentQuestionnairePerspective');
var AppointmentFormPerspective = require('./appointment-form/AppointmentFormPerspective');
var AuthPerspective = require('./authentication/AuthPerspective');
var BillTabsPerspective = require('./bill/BillTabsPerspective');
var BillTabsView = require('./bill/BillTabsView');
var DashboardPerspective = require('./dashboard/DashboardPerspective');
var creditCardEncryptionService = require('./payment/creditCardEncryptionService');
var EregAppPerspective = require('./ereg/EregAppPerspective');
var EregAuthBarcodePerspective = require('./ereg/patient-authentication/EregAuthBarcodePerspective');
var EregAuthMethodConfigPerspective = require('./ereg/patient-authentication/EregAuthMethodConfigPerspective');
var EregAuthFormView = require('./ereg/patient-authentication/EregAuthFormView');
var EregPatientAppointmentsPerspective = require('./ereg/patient-appointments/EregPatientAppointmentsPerspective');
var EregStaffPatientAppointmentsPerspective = require('./ereg/staff-patient-appointments/EregStaffPatientAppointmentsPerspective');
var EregStaffPatientLookupPerspective = require('./ereg/staff-patient-lookup/EregStaffPatientLookupPerspective');
var EregStaffPlaceholderAppointmentEditPerspective = require('./ereg/staff-placeholder-appointment-edit/EregStaffPlaceholderAppointmentEditPerspective');
var EregStaffSelectWorkflowPerspective = require('./ereg/staff-select-workflow/EregStaffSelectWorkflowPerspective');
var launcherAppInterface = require('./launcherApplicationInterface');
var OnsiteDetailsPerspective = require('./onsite-details/OnsiteDetailsPerspective');
var PatientProfilePerspective = require('./patient-profile/PatientProfilePerspective');
var PatientSignupPerspective = require('./signup/PatientSignupPerspective');
var PatientSettingsPerspective = require('./settings/PatientSettingsPerspective');
var PaymentPerspective = require('./payment/PaymentPerspective');
var PerspectiveRouter = require('./perspectiveManager/PerspectiveRouter');
var StoredPaymentMethodEditPerspective = require('./payment-method/StoredPaymentMethodEditPerspective');
var TimeoutWidgetView = require('./timeout/TimeoutWidgetView');
var WizardWidget = require('./wizard/WizardWidget');
var WizardButtonsView = require('./wizard/WizardButtonsView');
var wizardUtils = require('./wizard/wizardUtils');
var eregWorkflowConfigService = require('./wizard/eregWorkflowConfigService');
var patientNavView = require('./nav/navViews').patient;
var portalLoadingPerspective = require('./widget/loading/portalLoadingPerspective');
var screenSizeView = require('./widget/screen-size/screenSizeView');
var authenticationFeatureConfigModel = require('./authentication/authenticationFeatureConfigModel');

/**
 * Router App for the portal flow.
 *
 * @class portalMain
 * @static
 */
var portalMain = new (PerspectiveRouter.extend({
  _authenticationRequired: true,
  _disposePerspective: false,

  /**
   * The method will be invoked on this router object when the user navigates to the given hash.
   * To support proxy the hashes should all start with '/patient/:patientVecnaId' and use the patient vecna id to determine the data they display.
   *
   * @property routes {Object} mapping from hash to method.
   */
  routes: {
    '(/)(page/:page)': '_defaultRoute',
    'loading': '_loading',
    'tablet(/serialNumber/:serialNumber)': '_determineAuthenticationMethod',
    'patient/authentication/manual': '_manualPatientAuthentication',
    'patient/authentication/barcode': '_barcodePatientAuthentication',
    'patient/signup': '_patientSignup',
    'patient/:patientVecnaId(/)(page/:page)': '_dashboard',
    'patient/:patientVecnaid/appointment(/page/:page)': '_appointmentDefault',
    'patient/:patientVecnaid/appointment/upcoming(/page/:page)': '_appointmentUpcoming',
    'patient/:patientVecnaid/appointment/past(/page/:page)': '_appointmentPast',
    'patient/:patientVecnaId/appointment/:appointmentExternalId': '_appointmentDetails',
    'patient/:patientVecnaId/appointments/:regDate': '_multipleAppointmentDetails',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/bill': '_appointmentBill',
    'patient/:patientVecnaId/appointments/:regDate/bill': '_multipleAppointmentBill',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/expressCheckin': '_appointmentExpressCheckin',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/insurance': '_appointmentInsurance',
    'patient/:patientVecnaId/appointments/:regDate/insurance(/:appointmentExternalId)': '_multiAppointmentInsurance',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/form': '_appointmentForms',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/form/:formName': '_appointmentForm',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/payment': '_appointmentPayment',
    'patient/:patientVecnaId/appointments/:regDate/payment': '_multipleAppointmentPayment',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/profile': '_appointmentProfile',
    'patient/:patientVecnaId/appointments/:regDate/profile': '_multipleAppointmentProfile',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/reg': '_appointmentPreReg',
    'patient/:patientVecnaId/appointments/:regDate/reg': '_multiAppointmentPreReg',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/questionnaire': '_appointmentQuestionnaires',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/questionnaire/:questionnaireName': '_singleAppointmentQuestionnaire',
    'patient/:patientVecnaId/appointments/:regDate/questionnaire': '_multipleAppointmentsQuestionnaires',
    'patient/:patientVecnaId/appointments/:regDate/questionnaire/:appointmentExternalId/:questionnaireName': '_appointmentQuestionnaire',
    'patient/:patientVecnaId/appointment/:appointmentExternalId/queued': '_appointmentQueued',
    'patient/:patientVecnaId/bill(/page/:page)': '_billDefault',
    'patient/:patientVecnaId/bill/paid(/page/:page)': '_billPaid',
    'patient/:patientVecnaId/bill/due(/page/:page)': '_billDue',
    'patient/:patientVecnaId/bill/:billId': '_billDetails',
    'patient/:patientVecnaId/bill/:billId/payment': '_billPayment',
    'patient/:patientVecnaId/payment': '_makePayment',
    'patient/:patientVecnaId/estimate(/page/:page)': '_estimate',
    'patient/:patientVecnaId/estimate/:accountExternalId': '_estimateDetails',
    'patient/:patientVecnaId/profile': '_patientProfile',
    'patient/:patientVecnaId/receipt(/page/:page)': '_receipt',
    'patient/:patientVecnaId/receipt/:receiptVecnaId': '_receiptDetails',
    'patient/:patientVecnaId/settings': '_patientSettings',
    'patient/:patientVecnaId/stored-payment-method/edit(/:storedPaymentMethodId)': '_editStoredPaymentMethod',
    'staff/authentication': '_staffAuthentication',
    'staff/patient': '_staffPatientLookup',
    'staff/patient/:patientVecnaId/appointment': '_staffPatientAppointments',
    'staff/patient/:patientVecnaId/appointment/placeholder/edit': '_staffPlaceholderAppointmentEdit',
    'staff/patient/:patientVecnaId/appointment/:appointmentId/workflow': '_staffSelectWorkflow',
    'staff/patient/:patientVecnaId/appointments/:regDate/workflow': '_multiAppointmentStaffSelectWorkflow',
    '*path':  '_404' // '404' default route - must be last.
  },

  /**
   * @property routeCallbacksWithoutAuthentication {String[]} List of route callbacks that should not have authentication applied to them.
   */
  _routeCallbacksWithoutAuthentication: [
    '_determineAuthenticationMethod',
    '_manualPatientAuthentication',
    '_barcodePatientAuthentication',
    '_staffAuthentication',
    '_patientSignup',
    '_loading'
  ],

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    PerspectiveRouter.prototype.initialize.apply(this);
    _.bindAll(this, '_determineAuthenticationMethod', '_manualPatientAuthentication', '_barcodePatientAuthentication', '_loading');
    this._eregApp = new EregAppPerspective();

    this._dashboardPerspectives = {};
    this._appointmentDetailsPerspectives = {};
    this._multiAppointmentConfirmationPerspective = {};
    this._appointmentBillPerspectives = {};
    this._appointmentInsurancePerspectives = {};
    this._appointmentQuestionnairePerspectives = {};
    this._appointmentFormPerspectives = {};
    this._appointmentPaymentPerspectives = {};
    this._appointmentProfilePerspectives = {};
    this._appointmentTabsPerspectives = {};
    this._appointmentTabsViews = {};
    this._billTabsPerspectives = {};
    this._billTabsViews = {};
    this._onsiteDetailsPerspectives = {};
    this._patientProfilePerspectives = {};
    this._patientSettingsPerspectives = {};
    this._staffPatientAppointmentsPerspectives = {};
    this._staffPlaceholderAppointmentEditPerspectives = {};
    this._staffSelectWorkflowPerspectives = {};

    creditCardEncryptionService.getEncryptionScript();
  },

  /**
   * Starts the application.
   * Stop the history if it's already started. Bind the routes, and start the history.
   *
   * @method start
   */
  start: function() {
    Backbone.history.stop();
    this._bindRoutes();
    Backbone.history.start();

    screenSizeView.attachTo($('.screen-size'));

    userService.resetAndFetchModels();

    this.listenTo(userService.currentVisitModel, 'change:id', this._setVisitIdOnDOM);
    this._setVisitIdOnDOM();

    this.listenTo(userService.currentUserModel, 'change:vecnaId', this._setVecnaIdOnDOM);
    this._setVecnaIdOnDOM();
  },

  /**
   * Initializes the authentication perspective and renders it
   *
   * @method _authentication
   * @param [navigateToPageFn] {Function} execute this after authentication completes to go to the correct route.
   * @param [afterLoginHash] {String} - hash to use after login.
   * @private
   */
  _authentication: function(navigateToPageFn, afterLoginHash) {
    var serialNumber = null;
    this._determineAuthenticationMethod(serialNumber, navigateToPageFn, afterLoginHash);
  },

  /**
   * This displays a full-page loading screen while we wait for server data to load.
   * This should only be used in the cases where we do not have another perspective to show while data is loading.
   * @method _loading
   * @private
   */
  _loading: function() {
    var disposePerspective = false;
    this._switchPerspectives(portalLoadingPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
  },

  /**
   * Get the current visit id from the userService and set it on the body DOM
   * @method _setVisitIdOnDOM
   * @private
   */
  _setVisitIdOnDOM: function() {
    var currentVisitId = userService.currentVisitModel.get('id');
    $('body').attr('visit-id', currentVisitId);
  },

  /**
   * Get the current patient vecna id from the userService and set it on the body DOM
   * @method _setVecnaIdOnDOM
   * @private
   */
  _setVecnaIdOnDOM: function() {
    var patientVecnaId = userService.currentUserModel.get('vecnaId');
    $('body').attr('patient-vecna-id', patientVecnaId);
  },

  /**
   * Return the timeout widget options depending on application
   * @method _getTimeoutWidgetOptions
   * @private
   */
  _getTimeoutWidgetOptions: function() {
    var timeoutWidgetOptions;
    if (launcherAppInterface.isAtHospital() || applicationUtils.currentApplication === applicationUtils.APPLICATIONS.EREG) {
      timeoutWidgetOptions = {
        logoutUrl: applicationUtils.APPLICATIONS.EREG.logoutUrl,
        idleAfter: $.i18n.prop('timeout.ereg.idleAfter'),
        warningLength: $.i18n.prop('timeout.ereg.warningLength')
      };
    } else {
      timeoutWidgetOptions = {
        logoutUrl: applicationUtils.APPLICATIONS.PATIENT_PORTAL.logoutUrl,
        keepAliveUrl: urls.refreshUrl,
        keepAliveMethod: 'POST'
      };
    }
    return timeoutWidgetOptions;
  },

  /**
   * Setup the timeout widget for the application.
   *
   * @method _setupTimeoutWidget
   * @private
   */
  _setupTimeoutWidget: function() {
    this._timeoutWidget = new TimeoutWidgetView(this._getTimeoutWidgetOptions());
    this._timeoutWidget.attachTo($('.timeout-widget'));
  },

  /**
   * Redirect to the dashboard with the current patient's vecna id and the given page number.
   * @method _defaultRoute
   * @param [page] {Number} the 1-based page number of the page of the list of todos to display.
   * @private
   */
  _defaultRoute: function(page) {
    var newHash;
    if (launcherAppInterface.isAtHospital()) {
      // for ereg do not navigate back to dashboard page.  Navigate to login page on page not found.
      newHash = 'patient/authentication/manual';
    } else {
      var pageNumberHashSuffix = '';
      if (!_.isUndefined(page) && !_.isNull(page)) {
        pageNumberHashSuffix = '/page/' + page;
      }
      newHash = 'patient/' + userService.currentUserModel.get('vecnaId') + pageNumberHashSuffix;
    }
    this.navigate(newHash, { trigger: true });
  },

  /**
   * Determines which page users should be using for authentication.
   *
   * @method _determineAuthenticationMethod
   * @param [serialNumber] {String} the serialNumber of this tablet to save in the session
   * @param [navigateToPageFn] {Function} execute this after authentication completes to go to the correct route.
   * @param [redirectURL] {String} - hash to use after login.
   * @private
   */
  _determineAuthenticationMethod: function(serialNumber, navigateToPageFn, redirectURL) {
    //If at hospital, redirect to the ereg app
    if (applicationUtils.currentApplication === applicationUtils.APPLICATIONS.EREG) {
      launcherAppInterface.setAtHospital();
      if (serialNumber !== null) {
        sessionStorageService.setItem(SERIAL_NUMBER_PROPERTY_NAME, serialNumber);
      }
      var authenticationPerspective = new EregAuthMethodConfigPerspective();
      // Due to the sensitive nature, we want to dispose the authentication perspective.
      var disposePerspective = true;
      this._switchPerspectives(authenticationPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
    } else {
      launcherAppInterface.setAtHome();
      authenticationFeatureConfigModel.loadOnce()
        .then(function() {
          this._authenticationBasedOnConfiguration(navigateToPageFn, redirectURL);
        }.bind(this));
    }
  },

  /**
   * Allows users to login to the application.
   *
   * @method _manualPatientAuthentication
   * @param [navigateToPageFn] {Function} execute this after authentication completes to go to the correct route.
   * @param [redirectURL] {String} - hash to use after login.
   * @private
   */
  _manualPatientAuthentication: function(navigateToPageFn, redirectURL) {
    //If at hospital, redirect to the ereg app
    if (launcherAppInterface.isAtHospital() || applicationUtils.currentApplication === applicationUtils.APPLICATIONS.EREG) {
      // If at hospital, redirect to the ereg app
      var authenticationPerspective = new AuthPerspective({
        authContext: AuthPerspective.AUTH_CONTEXTS.EREG_PATIENT,
        formView: EregAuthFormView,
        moduleNamespace: 'eregPatientAuthPerspective'
      });
      // Due to the sensitive nature, we want to dispose the authentication perspective.
      var disposePerspective = true;

      this._switchPerspectives(authenticationPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
    } else {
      authenticationFeatureConfigModel.loadOnce()
        .then(function() {
          this._authenticationBasedOnConfiguration(navigateToPageFn, redirectURL);
        }.bind(this));
    }
  },

  /**
   * Allows users to login to the application via barcode.
   *
   * @method _barcodePatientAuthentication
   * @param [navigateToPageFn] {Function} execute this after authentication completes to go to the correct route.
   * @param [redirectURL] {String} - hash to use after login.
   * @private
   */
  _barcodePatientAuthentication: function(navigateToPageFn, redirectURL) {
    //If at hospital, redirect to the ereg app's barcode authentication page
    if (launcherAppInterface.isAtHospital() || applicationUtils.currentApplication === applicationUtils.APPLICATIONS.EREG) {
      var barcodeAuthPerspective = new EregAuthBarcodePerspective({context: EregAuthBarcodePerspective.PAGE_CONTEXT.START_SCAN});

      // Due to the sensitive nature, we want to dispose the authentication perspective.
      var disposePerspective = true;
      this._switchPerspectives(barcodeAuthPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
    } else {
      authenticationFeatureConfigModel.loadOnce()
        .then(function() {
          this._authenticationBasedOnConfiguration(navigateToPageFn, redirectURL);
        }.bind(this));
    }
  },

  /**
   * Either initializes the authentication perspective and renders it or redirects to CAS depending on the configuration
   * of the authentication feature configuration.
   *
   * @method _authenticationBasedOnConfiguration
   * @param [navigateToPageFn] {Function} execute this after authentication completes to go to the correct route.
   * @param [redirectURL] {String} - hash to use after login.
   * @private
   */
  _authenticationBasedOnConfiguration: function(navigateToPageFn, redirectURL) {
    var authenticationContext = authenticationFeatureConfigModel.get('patientAuthenticationContext');

    // If cas then redirect to cas, otherwise use the AuthPerspective.
    if (applicationUtils.AUTHENTICATION_CONTEXTS.CAS === authenticationContext) {
      var loginUrl = applicationUtils.currentApplication.getLoginUrl(routerUtils.cleanRedirectURL(redirectURL));
      window.location.href = loginUrl;
    } else {
      var authenticationPerspective = new AuthPerspective({
        authContext: AuthPerspective.AUTH_CONTEXTS.PATIENT_PORTAL,
        navigateToPageFn: navigateToPageFn
      });
      // Due to the sensitive nature, we want to dispose the authentication perspective.
      var disposePerspective = true;
      this._switchPerspectives(authenticationPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
    }
  },

  /**
   * Initializes the patient signup perspective
   * @method _patientSignup
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _patientSignup: function(queryParams) {
    var queryObject = routerUtils.parseQueryString(queryParams);
    var inviteId = queryObject.inviteId;
    var patientSignupPerspective = new PatientSignupPerspective({inviteId: inviteId});
    var disposePerspective = true;
    this._switchPerspectives(patientSignupPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
  },

  /**
   * Initializes the dashboard perspective if not already done, and renders it.
   * Based on the url parameters specified, this will display the given page on the dashboard todo list
   * @method _dashboard
   * @param [patientVecnaId] {String} the Vecna id of the patient to display the dashboard
   * @param [page] {Number} the 1-based page number of the page of the list of todos to display.
   * @private
   */
  _dashboard: function(patientVecnaId, page) {
    var dashboardPerspective;
    if (patientVecnaId) {
      if (!this._dashboardPerspectives[patientVecnaId]) {
        this._dashboardPerspectives[patientVecnaId] = new DashboardPerspective({
          patientVecnaId: patientVecnaId,
          page: page
        });
      }
      dashboardPerspective = this._dashboardPerspectives[patientVecnaId];
    } else {
      if (!this._dashboardPerspective) {
        this._dashboardPerspective = new DashboardPerspective({
          page: page
        });
      }
      dashboardPerspective = this._dashboardPerspective;
    }
    dashboardPerspective.setRouteContext({
      page: page
    });
    this._switchPerspectives(dashboardPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.DASHBOARD, patientNavView.TOP_LEVEL_NAV_ITEMS.PATIENT_NAME, false);
  },

  /**
   * Initializes the patient appointment bill perspective and renders it appropriately for multi or single appointment
   * checked in.
   *
   * @method _generalAppointmentBill
   * @param options {Object}
   *   @param options.patientVecnaId {String} the Vecna id of the patient to view the bill of.
   *   @param options.appointmentExternalId {String} the external id of the appointment to view the bill of
   *   @param options.regDate {String} Date of the appointments being prereged to view the bill of
   *   @param options.queryParams {String} the query parameters from the url.
   * @private
   */
  _generalAppointmentBill: function(options) {
    var navigationDirection = this._getWizardNavigationDirection(options.queryParams);
    var shouldDispose = false;
    var patientVecnaId = options.patientVecnaId;
    var secondaryId = options.regDate || options.appointmentExternalId;
    if (!this._appointmentBillPerspectives[patientVecnaId]) {
      this._appointmentBillPerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentBillPerspectives[patientVecnaId][secondaryId]) {
      this._appointmentBillPerspectives[patientVecnaId][secondaryId] =
          new AppointmentBillPerspective({
            patientVecnaId: patientVecnaId,
            appointmentExternalId: options.appointmentExternalId,
            regDate: options.regDate
          });
    }
    this._appointmentBillPerspectives[patientVecnaId][secondaryId].navigateToWizardPage({
      lastNavigationDirection: navigationDirection
    });
    this._switchPerspectives(this._appointmentBillPerspectives[patientVecnaId][secondaryId],
                             patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, shouldDispose);
  },

  /**
   * Initializes the patient appointment estimated bill (and all outstanding bills) view perspective and renders it.
   *
   * @method _appointmentBill
   * @param appointmentExternalId {String} the id of the appointment to display the estimated bill for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the estimated bill for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentBill: function(patientVecnaId, appointmentExternalId, queryParams) {
    this._generalAppointmentBill({
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId,
      queryParams: queryParams
    });
  },

  /**
   * Initializes the patient appointment estimated bill (and all outstanding bills) view perspective
   * and renders it when multiple appointments are being checked in.
   *
   * @method _multipleAppointmentProfile
   * @param patientVecnaId {String} the Vecna id of the patient to view the bill of.
   * @param regDate {String} Date of the appointments being prereged to view the bill of.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _multipleAppointmentBill: function(patientVecnaId, regDate, queryParams) {
    this._generalAppointmentBill({
      patientVecnaId: patientVecnaId,
      regDate: regDate,
      queryParams: queryParams
    });
  },

  /**
   * Initializes the patient appointment's onsite view and renders it, depending on if it is an express check in or queued view
   *
   * @method _appointmentOnsite
   * @param isExpressCheckin {Boolean} whether or not this appointment is express checkin or queued
   * @param appointmentExternalId {String} the id of the appointment to display the express checkin message for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the express checkin message for.
   * @private
   */
  _appointmentOnsite: function(isExpressCheckin, patientVecnaId, appointmentExternalId) {
    var viewType = isExpressCheckin ? ONSITE_VIEWS.EXPRESS_CHECKIN_VIEW : ONSITE_VIEWS.QUEUED_VIEW;
    if (!this._onsiteDetailsPerspectives[patientVecnaId]) {
      this._onsiteDetailsPerspectives[patientVecnaId] = {};
    }
    if (!this._onsiteDetailsPerspectives[patientVecnaId][appointmentExternalId]) {
      this._onsiteDetailsPerspectives[patientVecnaId][appointmentExternalId] = {};
    }
    if (!this._onsiteDetailsPerspectives[patientVecnaId][appointmentExternalId][viewType]) {
      this._onsiteDetailsPerspectives[patientVecnaId][appointmentExternalId][viewType] =
          new OnsiteDetailsPerspective({
            patientVecnaId: patientVecnaId,
            appointmentExternalId: appointmentExternalId,
            isExpressCheckin: isExpressCheckin
          });
    }
    this._switchPerspectives(this._onsiteDetailsPerspectives[patientVecnaId][appointmentExternalId][viewType],
        patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   * Initializes the patient appointment's express checkin view and renders it.
   *
   * @method _appointmentExpressCheckin
   * @param appointmentExternalId {String} the id of the appointment to display the express checkin message for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the express checkin message for.
   * @private
   */
  _appointmentExpressCheckin: function(patientVecnaId, appointmentExternalId) {
    this._appointmentOnsite(true, patientVecnaId, appointmentExternalId);
  },

  /**
   * Initializes the patient appointment's queued view and renders it.
   *
   * @method _appointmentQueued
   * @param appointmentExternalId {String} the id of the appointment to display the express checkin message for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the express checkin message for.
   * @private
   */
  _appointmentQueued: function(patientVecnaId, appointmentExternalId) {
    this._appointmentOnsite(false, patientVecnaId, appointmentExternalId);
  },

  /**
   * Initializes the patient appointment details view perspective and renders it.
   *
   * @method _appointmentDetails
   * @param appointmentExternalId {String} the id of the appointment to display the estimated bill for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the estimated bill for.
   * @param queryParams {String} String containing the fake hash query parameters.
   * @private
   */
  _appointmentDetails: function(patientVecnaId, appointmentExternalId, queryParams) {
    var queryObject = routerUtils.parseQueryString(queryParams);
    if (!this._appointmentDetailsPerspectives[patientVecnaId]) {
      this._appointmentDetailsPerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentDetailsPerspectives[patientVecnaId][appointmentExternalId]) {
      this._appointmentDetailsPerspectives[patientVecnaId][appointmentExternalId] =
        new AppointmentDetailsPerspective({
          patientVecnaId: patientVecnaId,
          appointmentExternalId: appointmentExternalId
        });
    } else {
      this._appointmentDetailsPerspectives[patientVecnaId][appointmentExternalId].refreshAppointmentData();
    }
    this._appointmentDetailsPerspectives[patientVecnaId][appointmentExternalId].setRouteContext(queryObject);
    this._switchPerspectives(this._appointmentDetailsPerspectives[patientVecnaId][appointmentExternalId],
                             patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   * Initializes the patient appointment confirmation view perspective and renders it when multiple appointments are being checked in.
   *
   * @param patientVecnaId {String} the Vecna id of the patient to display the appointment confirmation for.
   * @param regDate {String} Date of the appointments being prereged to display the appointment confirmation for.
   * @private
   */
  _multipleAppointmentDetails: function(patientVecnaId, regDate) {
    if (!this._multiAppointmentConfirmationPerspective[patientVecnaId]) {
      this._multiAppointmentConfirmationPerspective[patientVecnaId] = {};
    }
    if (!this._multiAppointmentConfirmationPerspective[patientVecnaId][regDate]) {
      this._multiAppointmentConfirmationPerspective[patientVecnaId][regDate] =
          new MultiAppointmentConfirmationPerspective({
            patientVecnaId: patientVecnaId,
            regDate: regDate
          });
    }
    this._switchPerspectives(this._multiAppointmentConfirmationPerspective[patientVecnaId][regDate],
        patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   * Initializes the patient appointment insurance view perspective and renders it.
   *
   * @method _appointmentInsurance
   * @param patientVecnaId {String} the Vecna id of the patient to display the insurances for.
   * @param appointmentExternalId {String} the id of the appointment to display the insurances for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentInsurance: function(patientVecnaId, appointmentExternalId, queryParams) {
    var navigationDirection = this._getWizardNavigationDirection(queryParams);
    this._generalAppointmentInsurance({
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId,
      navigationDirection: navigationDirection
    });
  },

  /**
   * Initializes the patient appointment insurance view perspective and renders it.
   *
   * @method _appointmentInsurance
   * @param patientVecnaId {String} the Vecna id of the patient to display the insurances for.
   * @param [stepAppointmentExternalId] {String} the id of the appointment to display the insurances for.
   * @param regDate {String} Date of the appointments being to display the insurances for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _multiAppointmentInsurance: function(patientVecnaId, regDate, stepAppointmentExternalId, queryParams) {
    var navigationDirection = this._getWizardNavigationDirection(queryParams);
    if (stepAppointmentExternalId) {
      this._generalAppointmentInsurance({
        patientVecnaId: patientVecnaId,
        regDate: regDate,
        stepAppointmentExternalId: stepAppointmentExternalId,
        navigationDirection: navigationDirection
      });
    } else {
      this._navigateToFirstMultiInsuranceRegStep({
        patientVecnaId: patientVecnaId,
        regDate: regDate,
        navigationDirection: navigationDirection
      });
    }
  },

  /**
   * @method _navigateToFirstMultiInsuranceRegStep
   * @param wizardOptions {Object}
   *   @param wizardOptions.patientVecnaId {String} the vecna id of the patient using the wizard.
   *   @param wizardOptions.regDate {String} the date of the registrations being process (for multi-appts).
   *   @param wizardOptions.navigationDirection {String} the navigation direction (forwards or backwards) through the wizard.
   * @private
   */
  _navigateToFirstMultiInsuranceRegStep: function(wizardOptions) {
    var router = this;
    var wizardWidget = WizardWidget.getWizardWidget(wizardOptions);
    var insuranceStepHash = 'appointmentPreRegInsurance';

    wizardWidget.getFetchWizardConfigDeferred()
      .then(function(wizardData) {
        var insuranceWizardStep = _.find(wizardData.wizardSteps, function(wizardStep) {
          return wizardStep.hash === insuranceStepHash;
        });
        var firstInsuranceSubWizard = _.first(insuranceWizardStep.children);
        var disabledSteps = eregWorkflowConfigService.getDisabledWizardSteps(wizardOptions);
        var step = wizardUtils.getFirstEnabledStepFromWizardData(firstInsuranceSubWizard, disabledSteps);
        step = step || _.first(firstInsuranceSubWizard.wizardSteps);
        if (router._skipStepIfInvalidAndNavigate(wizardOptions, step, WizardButtonsView.PAGE_NAMES.INSURANCE)) {
          return;
        }
        wizardOptions.hash = step.hash;
        wizardOptions.stepAppointmentExternalId = step.appointmentExternalId;
        var insurancePageHash = wizardUtils.getPageHash(wizardOptions);
        router.navigate(insurancePageHash, {
          trigger: true,
          replace: true
        });
      });
  },

  /**
   * Initializes the patient appointment insurance view perspective and renders it.
   *
   * @method _appointmentInsurance
   * @param options {Object}
   *   @param options.patientVecnaId {String} the Vecna id of the patient to display the insurances for.
   *   @param options.appointmentExternalId {String} the id of the appointment to display the insurances for.
   *   @param options.regDate {String} Date of the appointments being to display the insurances for.
   *   @param options.stepAppointmentExternalId {String} the id of the appointment to display the insurances for.
   *   @param options.navigationDirection {String} the navigation direction (forwards or backwards) through the wizard.
   * @private
   */
  _generalAppointmentInsurance: function(options) {
    var patientVecnaId = options.patientVecnaId;
    var regDateId = options.regDate + options.stepAppointmentExternalId;
    var secondaryId = options.regDate ? regDateId : options.appointmentExternalId;
    if (!this._appointmentInsurancePerspectives[patientVecnaId]) {
      this._appointmentInsurancePerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentInsurancePerspectives[patientVecnaId][secondaryId]) {
      this._appointmentInsurancePerspectives[patientVecnaId][secondaryId] =
        new AppointmentInsurancePerspective({
          patientVecnaId: patientVecnaId,
          appointmentExternalId: options.appointmentExternalId || options.stepAppointmentExternalId,
          regDate: options.regDate,
          stepAppointmentExternalId: options.stepAppointmentExternalId
        });
    }
    this._appointmentInsurancePerspectives[patientVecnaId][secondaryId].navigateToWizardPage({
      lastNavigationDirection: options.navigationDirection,
      appointmentExternalId: options.stepAppointmentExternalId
    });
    this._switchPerspectives(this._appointmentInsurancePerspectives[patientVecnaId][secondaryId],
      patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   * Initializes the patient appointment payment view perspective and renders it.
   *
   * @method _appointmentPayment
   * @param patientVecnaId {String} the Vecna id of the patient to display the payment information for.
   * @param appointmentExternalId {String} the id of the appointment to display the payment information for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentPayment: function(patientVecnaId, appointmentExternalId, queryParams) {
    this._generalAppointmentPayment({
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId,
      queryParams: queryParams
    });
  },

  /**
   * Initializes the patient appointment payment view perspective and renders it when multiple appointments are being checked in.
   *
   * @method _multipleAppointmentPayment
   * @param patientVecnaId {String} the Vecna id of the patient to display the payment information for.
   * @param regDate {String} Date of the appointments being prereged to display the payment information for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _multipleAppointmentPayment: function(patientVecnaId, regDate, queryParams) {
    this._generalAppointmentPayment({
      patientVecnaId: patientVecnaId,
      regDate: regDate,
      queryParams: queryParams
    });
  },

  /**
   * nitializes the patient appointment payment view perspective and renders it appropriately for multi or single appointment
   * checked in.
   *
   * @method _generalAppointmentPayment
   * @param options {Object}
   *   @param options.patientVecnaId {String} the Vecna id of the patient to display the payment information for.
   *   @param options.appointmentExternalId {String} the external id of the appointment to display the payment information for.
   *   @param options.regDate {String} Date of the appointments being prereged to display the payment information for.
   *   @param options.queryParams {String} the query parameters from the url.
   * @private
   */
  _generalAppointmentPayment: function(options) {
    var navigationDirection = this._getWizardNavigationDirection(options.queryParams);
    var shouldDispose = false;
    var patientVecnaId = options.patientVecnaId;
    var secondaryId = options.regDate || options.appointmentExternalId;
    if (!this._appointmentPaymentPerspectives[patientVecnaId]) {
      this._appointmentPaymentPerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentPaymentPerspectives[patientVecnaId][secondaryId]) {
      this._appointmentPaymentPerspectives[patientVecnaId][secondaryId] =
          new PaymentPerspective({
            patientVecnaId: patientVecnaId,
            appointmentExternalId: options.appointmentExternalId,
            regDate: options.regDate,
            moduleNamespace: 'appointmentPaymentPerspective'
          });
    }
    this._appointmentPaymentPerspectives[patientVecnaId][secondaryId].clearPaymentWidget();
    this._appointmentPaymentPerspectives[patientVecnaId][secondaryId].navigateToWizardPage({
      lastNavigationDirection: navigationDirection
    });
    this._switchPerspectives(this._appointmentPaymentPerspectives[patientVecnaId][secondaryId],
        patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, shouldDispose);
  },

  /**
   * Initializes the patient appointment profile perspective and renders it.
   *
   * @method _appointmentProfile
   * @param patientVecnaId {String} the Vecna id of the patient to view the profile of.
   * @param appointmentExternalId {String} the external id of the appointment to view the profile of
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentProfile: function(patientVecnaId, appointmentExternalId, queryParams) {
    this._generalAppointmentProfile({
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId,
      queryParams: queryParams
    });
  },

  /**
   * Initializes the patient appointment profile perspective and renders it when multiple appointments are being checked in.
   *
   * @method _multipleAppointmentProfile
   * @param patientVecnaId {String} the Vecna id of the patient to view the profile of.
   * @param regDate {String} Date of the appointments being prereged to view the profile of.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _multipleAppointmentProfile: function(patientVecnaId, regDate, queryParams) {
    this._generalAppointmentProfile({
      patientVecnaId: patientVecnaId,
      regDate: regDate,
      queryParams: queryParams
    });
  },

  /**
   * Initializes the patient appointment profile perspective and renders it appropriately for multi or single appointment
   * checked in.
   *
   * @method _generalAppointmentProfile
   * @param options {Object}
   *   @param options.patientVecnaId {String} the Vecna id of the patient to view the profile of.
   *   @param options.appointmentExternalId {String} the external id of the appointment to view the profile of
   *   @param options.regDate {String} Date of the appointments being prereged to view the profile of
   *   @param options.queryParams {String} the query parameters from the url.
   * @private
   */
  _generalAppointmentProfile: function(options) {
    var navigationDirection = this._getWizardNavigationDirection(options.queryParams);
    var shouldDispose = false;
    var patientVecnaId = options.patientVecnaId;
    var secondaryId = options.regDate || options.appointmentExternalId;
    if (!this._appointmentProfilePerspectives[patientVecnaId]) {
      this._appointmentProfilePerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentProfilePerspectives[patientVecnaId][secondaryId]) {
      this._appointmentProfilePerspectives[patientVecnaId][secondaryId] =
        new PatientProfilePerspective({
          patientVecnaId: patientVecnaId,
          appointmentExternalId: options.appointmentExternalId,
          regDate: options.regDate,
          moduleNamespace: 'appointmentProfilePerspective'
        });
    }
    this._appointmentProfilePerspectives[patientVecnaId][secondaryId].navigateToWizardPage({
      lastNavigationDirection: navigationDirection
    });
    this._switchPerspectives(this._appointmentProfilePerspectives[patientVecnaId][secondaryId],
      patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, shouldDispose);
  },

  /**
   * Routes to the first appropriate page in the *reg wizard.
   *
   * @method _appointmentPreReg
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param appointmentExternalId {String} the external id of the appointment to view the *reg for.
   * @private
   */
  _appointmentPreReg: function(patientVecnaId, appointmentExternalId) {
    this._generalAppointmentPreReg({
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId
    });
  },

  /**
   * Routes to the first appropriate page in the *reg wizard.
   *
   * @method _appointmentPreReg
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param regDate {String} the date of the appointments to view the *reg for.
   * @private
   */
  _multiAppointmentPreReg: function(patientVecnaId, regDate) {
    this._generalAppointmentPreReg({
      patientVecnaId: patientVecnaId,
      regDate: regDate
    });
  },

  /**
   * Routes to the first appropriate page in the *reg wizard.
   * Determines how to route based on whether the regDate vs. appointmentExternalId is defined.
   *
   * @method _generalAppointmentPreReg
   * @param wizardId {Object}
   *   @param wizardId.patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   *   @param wizardId.appointmentExternalId {String} the external id of the appointment to view the *reg for.
   *   @param wizardId.regDate {String} the date of the appointments to view the *reg for.
   * @private
   */
  _generalAppointmentPreReg: function(wizardId) {
    var router = this;
    var wizardWidget = WizardWidget.getWizardWidget(wizardId);

    wizardWidget.getFetchWizardConfigDeferred()
      .then(function(wizardData) {
        wizardUtils.logWizardStart(wizardData.appointmentExternalIds);

        var newPageHash = wizardUtils.getFirstEnabledStepPageHash(wizardData, wizardId);

        router.navigate(newPageHash, {
          trigger: true,
          replace: true
        });
      });
  },

  /**
   * Routes to the first appropriate questionnaire page in the *reg wizard.
   *
   * @method _appointmentQuestionnaires
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param appointmentExternalId {String} the external id of the appointment to view the *reg for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentQuestionnaires: function(patientVecnaId, appointmentExternalId, queryParams) {
    var lastNavigationDirection = this._getWizardNavigationDirection(queryParams);
    var wizardOptions = {
      patientVecnaId : patientVecnaId,
      appointmentExternalId : appointmentExternalId
    };
    this._generalAppointmentQuestionnaires(wizardOptions, lastNavigationDirection);
  },

  /**
   * Routes to the first appropriate questionnaire page in the *reg wizard.
   *
   * @method _multipleAppointmentsQuestionnaires
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param regDate {String} the date being registered for
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _multipleAppointmentsQuestionnaires: function(patientVecnaId, regDate, queryParams) {
    var lastNavigationDirection = this._getWizardNavigationDirection(queryParams);
    var wizardOptions = {
      patientVecnaId : patientVecnaId,
      regDate : regDate
    };
    this._generalAppointmentQuestionnaires(wizardOptions, lastNavigationDirection);
  },

  /**
   * Routes to the first appropriate questionnaire page in the *reg wizard.
   * @method _generalAppointmentQuestionnaires
   * @param wizardOptions the wizard options
   * @param lastNavigationDirection the navigation direction
   * @private
   */
  _generalAppointmentQuestionnaires: function(wizardOptions, lastNavigationDirection) {
    var wizardWidget = WizardWidget.getWizardWidget(wizardOptions);
    var router = this;
    wizardWidget.getFetchWizardConfigDeferred()
        .then(wizardWidget.fetchQuestionnaireWizardConfig)
        .then(function(questionnaireWizardData) {
          router._navigateToFirstAppointmentQuestionnaire(questionnaireWizardData, wizardOptions, lastNavigationDirection);
        });
  },

  /**
   * Actually navigates to the first wizard step once the wizard data has been fetched.
   *
   * @method _navigateToFirstAppointmentQuestionnaire
   * @param questionnaireWizardData {Object} that was fetched from the server for this appointment questionnaire step.
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param appointmentExternalId {String} the external id of the appointment to view the *reg for.
   * @param navigationDirection {String} either 'back', 'forward' or falsey - used to track the wizard navigation direction.
   * @private
   */
  _navigateToFirstAppointmentQuestionnaire: function(questionnaireWizardData, wizardOptions, navigationDirection) {
    var disabledSteps = eregWorkflowConfigService.getDisabledWizardSteps(wizardOptions);
    var step = wizardUtils.getFirstEnabledStepFromWizardData(questionnaireWizardData, disabledSteps);
    step = step || _.first(questionnaireWizardData.wizardSteps);
    if (this._skipStepIfInvalidAndNavigate(wizardOptions, step, WizardButtonsView.PAGE_NAMES.SURVEYS)) {
      return;
    }
    wizardOptions.hash = 'appointmentPreRegQuestionnaires';
    if (step.appointmentExternalId) {
      wizardOptions.stepAppointmentExternalId = step.appointmentExternalId;
    }
    var questionnairePageRootHash = wizardUtils.getPageHash(wizardOptions);
    var questionnaireName = step.urlParams.surveyName;
    var navigationDirectionQueryParams = wizardUtils.getNavigationDirectionQueryParameters(navigationDirection);
    var questionnaireHash = questionnairePageRootHash + '/' + encodeURIComponent(questionnaireName) + navigationDirectionQueryParams;
    this.navigate(questionnaireHash, {
      trigger: true,
      replace: true
    });
  },

  /**
   * Initializes the patient appointment questionnaire view perspective and renders it.
   *
   * @method _singleAppointmentQuestionnaire
   * @param patientVecnaId {String} the Vecna id of the patient to display the questionnaires for.
   * @param appointmentExternalId {String} the id of the appointment to display the questionnaires for.
   * @param questionnaireName {String} the name of the questionnaire to take.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _singleAppointmentQuestionnaire: function(patientVecnaId, appointmentExternalId, questionnaireName, queryParams) {
    this._appointmentQuestionnaire(patientVecnaId, null, appointmentExternalId, questionnaireName, queryParams);
  },

  /**
   * Initializes the patient appointment questionnaire view perspective and renders it.
   *
   * @method _appointmentQuestionnaire
   * @param appointmentExternalId {String} the id of the appointment to display the questionnaires for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the questionnaires for.
   * @param questionnaireName {String} the name of the questionnaire to take.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentQuestionnaire: function(patientVecnaId, regDate, appointmentExternalId, questionnaireName, queryParams) {
    var navigationDirection = this._getWizardNavigationDirection(queryParams);
    var options = {
        patientVecnaId: patientVecnaId,
        appointmentExternalId: appointmentExternalId,
        regDate: regDate,
        questionnaireName: decodeURIComponent(questionnaireName)
    };
    if (!this._appointmentQuestionnairePerspectives[patientVecnaId]) {
      this._appointmentQuestionnairePerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId]) {
      this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId] = {};
    }
    if (!this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId][questionnaireName]) {
      this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId][questionnaireName] =
        new AppointmentQuestionnairePerspective(options);
    } else {
      // if this appointment questionnaire perspective already exists, reinitialize the questionnaire to validate the rules
      this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId][questionnaireName].initializeQuestionnaire(options);
    }

    this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId][questionnaireName].navigateToWizardPage({
      lastNavigationDirection: navigationDirection,
      appointmentExternalId: appointmentExternalId
    });
    this._switchPerspectives(this._appointmentQuestionnairePerspectives[patientVecnaId][appointmentExternalId][questionnaireName],
      patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   * Routes to the first appropriate form page in the *reg wizard.
   *
   * @method _appointmentForms
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param appointmentExternalId {String} the external id of the appointment to view the *reg for.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentForms: function(patientVecnaId, appointmentExternalId, queryParams) {
    var lastNavigationDirection = this._getWizardNavigationDirection(queryParams);
    var wizardWidget = WizardWidget.getWizardWidget({
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId
    });
    wizardWidget.fetchFormsWizardConfig()
      .then(function(formWizardData) {
        this._navigateToFirstAppointmentForm(formWizardData, patientVecnaId, appointmentExternalId, lastNavigationDirection);
      }.bind(this));
  },

  /**
   * Actually navigates to the first wizard form step once the wizard data has been fetched.
   *
   * @method _navigateToFirstAppointmentForm
   * @param formWizardData {Object} that was fetched from the server for this appointment form step.
   * @param patientVecnaId {String} the Vecna id of the patient to view the *reg for.
   * @param appointmentExternalId {String} the external id of the appointment to view the *reg for.
   * @param navigationDirection {String} either 'back', 'forward' or falsey - used to track the wizard navigation direction.
   * @private
   */
  _navigateToFirstAppointmentForm: function(formWizardData, patientVecnaId, appointmentExternalId, navigationDirection) {
    var wizardOptions = {
      patientVecnaId: patientVecnaId,
      appointmentExternalId: appointmentExternalId
    };
    var disabledSteps = eregWorkflowConfigService.getDisabledWizardSteps(wizardOptions);
    var step = wizardUtils.getFirstEnabledStepFromWizardData(formWizardData, disabledSteps);
    step = step || _.first(formWizardData.wizardSteps);
    if (this._skipStepIfInvalidAndNavigate(wizardOptions, step, WizardButtonsView.PAGE_NAMES.FORMS)) {
      return;
    }
    wizardOptions.hash = 'appointmentPreRegForms';
    var formPageRootHash = wizardUtils.getPageHash(wizardOptions);
    var formName = encodeURIComponent(step.urlParams.name);
    var navigationDirectionQueryParams = wizardUtils.getNavigationDirectionQueryParameters(navigationDirection);
    var formHash = formPageRootHash + '/' + formName + navigationDirectionQueryParams;
    this.navigate(formHash, {
      trigger: true,
      replace: true
    });
  },

  /**
   * Skip the step if it is invalid and navigate to the proper page
   * @param wizardOptions {Object}
   *   @param wizardOptions.patientVecnaId {String} the patient's vecna id
   *   @param wizardOptions.appointmentExternalId {String} the appointment external id
   *   @param wizardOptions.regDate {String} the date for this reg
   * @param step the current wizard step
   * @param currentPageName the current page name
   * @returns {boolean} whether or not the step is invalid
   * @private
   */
  _skipStepIfInvalidAndNavigate: function(wizardOptions, step, currentPageName) {
    if (_.isUndefined(step)) {
      var wizardWidget = WizardWidget.getWizardWidget(wizardOptions);
      wizardWidget.getFetchWizardConfigDeferred()
          .then(function() {
            wizardWidget.wizardButtonsView.setPageAndStepInfo({ pageName: currentPageName });
            wizardWidget.continueNavigation();
          });
      return true;
    }
    if (ONSITE_VIEWS.QUEUED_VIEW === step.hash) {
      this._appointmentQueued(wizardOptions.patientVecnaId, wizardOptions.appointmentExternalId);
      return true;
    }
    return false;
  },

  /**
   * Initializes the patient appointment form view perspective and renders it.
   *
   * @method _appointmentForm
   * @param appointmentExternalId {String} the id of the appointment to display the insurances for.
   * @param patientVecnaId {String} the Vecna id of the patient to display the insurances for.
   * @param formName {String} the name of the form to take.
   * @param queryParams {String} the query parameters from the url.
   * @private
   */
  _appointmentForm: function(patientVecnaId, appointmentExternalId, formName, queryParams) {
    var navigationDirection = this._getWizardNavigationDirection(queryParams);

    if (!this._appointmentFormPerspectives[patientVecnaId]) {
      this._appointmentFormPerspectives[patientVecnaId] = {};
    }
    if (!this._appointmentFormPerspectives[patientVecnaId][appointmentExternalId]) {
      this._appointmentFormPerspectives[patientVecnaId][appointmentExternalId] = {};
    }
    if (!this._appointmentFormPerspectives[patientVecnaId][appointmentExternalId][formName]) {
      var options = {
        patientVecnaId: patientVecnaId,
        appointmentExternalId: appointmentExternalId,
        formName: decodeURIComponent(formName)
      };
      this._appointmentFormPerspectives[patientVecnaId][appointmentExternalId][formName] =
        new AppointmentFormPerspective(options);
    }

    this._appointmentFormPerspectives[patientVecnaId][appointmentExternalId][formName].navigateToWizardPage({
      lastNavigationDirection: navigationDirection
    });
    this._switchPerspectives(this._appointmentFormPerspectives[patientVecnaId][appointmentExternalId][formName],
      patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   * Parses the navigation direction that was appended to the url when navigating to the current page.
   * @param queryParametersString {String} the query parameters for this url.
   * @return {String} the navigation direction parsed from the query parameters.
   * @private
   */
  _getWizardNavigationDirection: function(queryParametersString) {
    var queryObject = routerUtils.parseQueryString(queryParametersString);
    return queryObject.navigationDirection;
  },

  /**
   * Based on the url parameters specified this will display the given tab on the appointments perspective.
   * @method _appointmentTabs
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecnaId of the user's bills that are being displayed.
   *   @param [options.tabName='upcoming'] {String} the name of the tab to render (should be one of AppointmentTabsView.TAB_NAMES i.e. UPCOMING, REQUESTED, PAST).
   *   @param [options.page=1] {Number} the 1-based page number of the page of the list to display.
   *   @param options.asideMessageKeys {Object} message keys for the aside.
   *     @param options.asideMessageKeys.asideHeaderMessageKey {String} message key for the aside.
   *     @param options.asideMessageKeys.asideContentMessageKey {String} message key for the aside.
   * @private
   */
  _appointmentTabs: function(options) {
    var patientVecnaId = options.patientVecnaId,
      routeContext = _.pick(options, 'patientVecnaId', 'tabName', 'page'),
      appointmentTabsView = this._appointmentTabsViews[patientVecnaId];

    if (!appointmentTabsView) {
      appointmentTabsView = new AppointmentTabsView(routeContext);
      this._appointmentTabsViews[patientVecnaId] = appointmentTabsView;
    } else {
      appointmentTabsView.setRouteContext(routeContext);
    }

    if (!this._appointmentTabsPerspectives[patientVecnaId]) {
      this._appointmentTabsPerspectives[patientVecnaId] = new AppointmentTabsPerspective({
        appointmentTabsView: appointmentTabsView
      });
    }
    asideView.updateAsideContent(options.asideMessageKeys);

    this._switchPerspectives(this._appointmentTabsPerspectives[patientVecnaId],
                             patientNavView.TOP_LEVEL_NAV_ITEMS.APPOINTMENT,
                             patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT,
                             false);
  },

  /**
   * Based on the launcher application, this will display the appointment list in portal or ereg
   *   portal: default tab on the appointment perspective
   *   ereg: patient appointment perspective
   *
   * @method _appointmentDefault
   * @param patientVecnaId the vecnaId of the user's appointments that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _appointmentDefault: function(patientVecnaId, page) {
    // If at hospital, redirect to the ereg appointment page
    if (launcherAppInterface.isAtHospital() || applicationUtils.currentApplication === applicationUtils.APPLICATIONS.EREG) {
      if (!this._patientAppointmentsPerspective) {
        this._patientAppointmentsPerspective = new EregPatientAppointmentsPerspective({ patientVecnaId: patientVecnaId });
      }
      this._patientAppointmentsPerspective.changePatientVecnaId(patientVecnaId);
      this._switchEregContent(this._patientAppointmentsPerspective);
    } else {
      this._appointmentTabs({
        patientVecnaId: patientVecnaId,
        page: page,
        asideMessageKeys: {
          asideHeaderMessageKey: 'appointment.aside.header',
          asideContentMessageKey: 'appointment.aside'
        }
      });
    }
  },

  /**
   * Based on the url parameters specified this will display the upcoming appointments tab on the appointments perspective.
   * @method _appointmentUpcoming
   * @param patientVecnaId the vecnaId of the user's appointments that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _appointmentUpcoming: function(patientVecnaId, page) {
    this._appointmentTabs({
      patientVecnaId: patientVecnaId,
      tabName: AppointmentTabsView.TAB_NAMES.UPCOMING,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'appointment.aside.header',
        asideContentMessageKey: 'appointment.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the past appointments tab on the appointments perspective.
   * @method _appointmentPast
   * @param patientVecnaId the vecnaId of the user's appointments that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _appointmentPast: function(patientVecnaId, page) {
    this._appointmentTabs({
      patientVecnaId: patientVecnaId,
      tabName: AppointmentTabsView.TAB_NAMES.PAST,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'appointment.aside.header',
        asideContentMessageKey: 'appointment.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the default tab on the bills perspective.
   * @method _billDefault
   * @param patientVecnaId the vecnaId of the user's bills that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _billDefault: function(patientVecnaId, page) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'bill.aside.header',
        asideContentMessageKey: 'bill.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the paid bills tab on the bills perspective.
   * @method _billPaid
   * @param patientVecnaId the vecnaId of the user's paid bills that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _billPaid: function(patientVecnaId, page) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      tabName: BillTabsView.TAB_NAMES.PAID_BILLS,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'bill.aside.header',
        asideContentMessageKey: 'bill.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the bills due tab on the bills perspective.
   * @method _billDue
   * @param patientVecnaId the vecnaId of the user's bills due that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _billDue: function(patientVecnaId, page) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      tabName: BillTabsView.TAB_NAMES.BILLS_DUE,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'bill.aside.header',
        asideContentMessageKey: 'bill.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the details of a bill.
   * @method _billDetails
   * @param patientVecnaId the vecnaId of the user's receipts that are being displayed.
   * @param billId the servicesId of the bill to show
   * @private
   */
  _billDetails: function(patientVecnaId, billId) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      billId: billId,
      asideMessageKeys: {
        asideHeaderMessageKey: 'bill.aside.header',
        asideContentMessageKey: 'bill.aside'
      }
    });
  },

  /**
   * Initializes the patient bill payment view perspective and renders it.
   *
   * @method _billPayment
   * @param patientVecnaId {String} the Vecna id of the patient to display the payment information for.
   * @param billId {String} the id of the bill to display the payment information for.
   * @private
   */
  _billPayment: function(patientVecnaId, billId) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      billId: billId,
      isPayment: true,
      asideMessageKeys: {
        asideHeaderMessageKey: 'bill.aside.header',
        asideContentMessageKey: 'bill.aside'
      }
    });
  },

  /**
   * Initializes the patient bill and estimate payment view perspective and renders it with no bills selected.
   *
   * @method _makePayment
   * @private
   * @param patientVecnaId {String} the Vecna id of the patient to display the payment information for.
   * @param queryParams {String} the query parameters passed in from the url.
   */
  _makePayment: function(patientVecnaId, queryParams) {
    var queryParameters = routerUtils.parseQueryString(queryParams);
    this._billTabs({
      patientVecnaId: patientVecnaId,
      accountExternalId: queryParameters.accountExternalId,
      appointmentExternalIds: queryParameters.appointmentExternalIds,
      isPayment: true,
      asideMessageKeys: {
        asideHeaderMessageKey: 'bill.aside.header',
        asideContentMessageKey: 'bill.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the estimates tab on the bills perspective.
   * @method _estimate
   * @param patientVecnaId the vecnaId of the user's receipts that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _estimate: function(patientVecnaId, page) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      tabName: BillTabsView.TAB_NAMES.ESTIMATES,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'estimate.aside.header',
        asideContentMessageKey: 'estimate.aside'
      }
    });
  },

  /**
   * Initializes the patient estimate details perspective and renders it.
   *
   * @method _estimateDetails
   * @param patientVecnaId {String} the Vecna id of the patient to display the estimate for.
   * @param accountExternalId {String} the external id of the account to display
   * @private
   */
  _estimateDetails: function(patientVecnaId, accountExternalId) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      accountExternalId: accountExternalId,
      asideMessageKeys: {
        asideHeaderMessageKey: 'estimate.aside.header',
        asideContentMessageKey: 'estimate.aside'
      }
    });
  },

  /**
   * Based on the url parameters specified this will display the given tab on the bills perspective.
   * @method _billTabs
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecnaId of the user's bills that are being displayed.
   *   @param [options.tabName='due'] {String} the name of the tab to render (should be one of BillTabsView.TAB_NAMES i.e. BILLS_DUE, PAID_BILLS, RECEIPTS).
   *   @param [options.page=1] {Number} the 1-based page number of the page of the list to display.
   *   @param [options.billId=null] {Number} the id of the bill details to display.
   *   @param [options.receiptVecnaId=null] {String} the vecna id of the receipt details to display.
   *   @param [options.isPayment=false] {Boolean} whether to render the make payment content in the tabs view.
   *   @param options.asideMessageKeys {Object} message keys for the aside.
   *     @param options.asideMessageKeys.asideHeaderMessageKey {String} message key for the aside.
   *     @param options.asideMessageKeys.asideContentMessageKey {String} message key for the aside.
   * @private
   */
  _billTabs: function(options) {
    var patientVecnaId = options.patientVecnaId,
      routeContext = _.pick(options, 'patientVecnaId', 'tabName', 'page', 'billId', 'receiptVecnaId', 'isPayment', 'accountExternalId'),
      billTabsView = this._billTabsViews[patientVecnaId];

    if (!billTabsView) {
      billTabsView = new BillTabsView(routeContext);
      this._billTabsViews[patientVecnaId] = billTabsView;
    }
    billTabsView.setRouteContext(routeContext);

    if (!this._billTabsPerspectives[patientVecnaId]) {
      this._billTabsPerspectives[patientVecnaId] = new BillTabsPerspective({
        billTabsView: billTabsView
      });
    }
    asideView.updateAsideContent(options.asideMessageKeys);

    this._switchPerspectives(this._billTabsPerspectives[patientVecnaId], patientNavView.TOP_LEVEL_NAV_ITEMS.FINANCIAL, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, false);
  },

  /**
   *Initializes the patient profile perspective and renders it.
   *
   * @method _patientProfile
   * @param patientVecnaId {String} the Vecna id of the patient to view the profile of.
   * @private
   */
  _patientProfile: function(patientVecnaId) {
    var shouldDispose = false;
    if (!this._patientProfilePerspectives[patientVecnaId]) {
      this._patientProfilePerspectives[patientVecnaId] = new PatientProfilePerspective({
        patientVecnaId: patientVecnaId,
        moduleNamespace: 'patientProfilePerspective'
      });
    }
    this._switchPerspectives(this._patientProfilePerspectives[patientVecnaId],
                             patientNavView.TOP_LEVEL_NAV_ITEMS.PROFILE,
                             patientNavView.TOP_LEVEL_NAV_ITEMS.PATIENT_NAME,
                             shouldDispose);
  },

  /**
   *Initializes the patient profile perspective and renders it.
   *
   * @method _patientSettings
   * @param patientVecnaId {String} the Vecna id of the patient to view the profile of.
   * @private
   */
  _patientSettings: function(patientVecnaId) {
    var shouldDispose = true;
    if (!this._patientSettingsPerspectives[patientVecnaId]) {
      this._patientSettingsPerspectives[patientVecnaId] = new PatientSettingsPerspective({
        patientVecnaId: patientVecnaId
      });
    }
    this._switchPerspectives(this._patientSettingsPerspectives[patientVecnaId],
                             patientNavView.TOP_LEVEL_NAV_ITEMS.SETTINGS,
                             patientNavView.TOP_LEVEL_NAV_ITEMS.PATIENT_NAME,
                             shouldDispose);
  },

  /**
   * Based on the url parameters specified this will display the receipt tab on the bills perspective.
   * @method _receipt
   * @param patientVecnaId the vecnaId of the user's receipts that are being displayed.
   * @param page the 1-based page number of the page of the list to display.
   * @private
   */
  _receipt: function(patientVecnaId, page) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      tabName: BillTabsView.TAB_NAMES.RECEIPTS,
      page: page,
      asideMessageKeys: {
        asideHeaderMessageKey: 'receipt.aside.header',
        asideContentMessageKey: 'receipt.aside'
      }
    });
  },

  /**
   * Initializes the patient receipt details perspective and renders it.
   *
   * @method _receiptDetails
   * @param patientVecnaId {String} the Vecna id of the patient to display the insurances for.
   * @param receiptVecnaId {String} the id of the receipt to display
   * @private
   */
  _receiptDetails: function(patientVecnaId, receiptVecnaId) {
    this._billTabs({
      patientVecnaId: patientVecnaId,
      receiptVecnaId: receiptVecnaId,
      asideMessageKeys: {
        asideHeaderMessageKey: 'receipt.aside.header',
        asideContentMessageKey: 'receipt.aside'
      }
    });
  },

  /**
   * Initializes the stored payment method edit perspective and renders it
   *
   * @method _editStoredPaymentMethod
   * @param patientVecnaId {String} the Vecna id of the patient creating/editing their stored payment
   * @param [storedPaymentMethodId] {String} the Vecna id of the stored payment method being edited
   * @private
   */
  _editStoredPaymentMethod: function(patientVecnaId, storedPaymentMethodId) {
    var shouldDispose = true;
    this._switchPerspectives(
      new StoredPaymentMethodEditPerspective({
        patientVecnaId: patientVecnaId,
        storedPaymentMethodId: storedPaymentMethodId
      }),
      patientNavView.TOP_LEVEL_NAV_ITEMS.PROFILE,
      patientNavView.TOP_LEVEL_NAV_ITEMS.PATIENT_NAME,
      shouldDispose
    );
  },

  /**
   * Initializes the staff authentication perspective and renders it
   *
   * @method _staffAuthentication
   * @private
   */
  _staffAuthentication: function() {
    var shouldDispose = true;
    // This is where we want to navigate to if the staff successfully authenticates.
    var navigateToPageFn = function() {
      window.location.href = '#staff/patient';
    };
    // Due to the sensitive nature, we want to dispose the authentication perspective.
    var newAuthPerspective = new AuthPerspective({
      authContext: AuthPerspective.AUTH_CONTEXTS.EREG_STAFF,
      moduleNamespace: 'eregStaffAuthPerspective',
      navigateToPageFn: navigateToPageFn
    });
    this._switchPerspectives(newAuthPerspective, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, shouldDispose);
  },

  /**
   * Uses the already initialized staff patient lookup perspective and renders it.
   *
   * @method _staffPatientLookup
   * @private
   */
  _staffPatientLookup: function() {
    if (!this._staffPatientLookupPerspective) {
      this._staffPatientLookupPerspective = new EregStaffPatientLookupPerspective();
    }
    this._switchEregContent(this._staffPatientLookupPerspective);
  },

  /**
   * Uses the already initialized staff facing patient appointment list perspective and renders it.
   * Will prevent switching to the new perspective if the previous perspective is the placeholder edit perspective and the
   * user has not confirmed that they want to navigate away from it.
   *
   * @method _staffPatientAppointments
   * @param patientVecnaId {String} the Vecna id of the patient that the staff is ereging.
   * @private
   */
  _staffPatientAppointments: function(patientVecnaId) {
    var currentPerspective = this._perspective;

    if (!this._staffPatientAppointmentsPerspectives[patientVecnaId]) {
      this._staffPatientAppointmentsPerspectives[patientVecnaId] = new EregStaffPatientAppointmentsPerspective({ patientVecnaId: patientVecnaId });
    }

    if (currentPerspective
        && currentPerspective.contentView
        && currentPerspective.contentView.isNavigateAwayConfirmed
        && !currentPerspective.contentView.isNavigateAwayConfirmed()) {
      currentPerspective.contentView.trigger('browserBack');
      Backbone.history.history.forward(); // Reset history since it has already changed.
    } else {
      this._switchEregContent(this._staffPatientAppointmentsPerspectives[patientVecnaId]);
    }
  },

  /**
   * Switches to the staff facing edit placeholder appointment perspective.
   * This keeps a map of appointment edit perspectives to appointment ids so that state is preserved across different appointment edits.
   * This also forces a placeholder instance of the perspective to be created for each unique or undefined appointment id.
   *
   * @method _staffPlaceholderAppointmentEdit
   * @param patientVecnaId {String} the Vecna id of the patient that the staff is ereging.
   * @private
   */
  _staffPlaceholderAppointmentEdit: function(patientVecnaId) {
    if (!this._staffPlaceholderAppointmentEditPerspectives[patientVecnaId]) {
      this._staffPlaceholderAppointmentEditPerspectives[patientVecnaId] = new EregStaffPlaceholderAppointmentEditPerspective({ patientVecnaId: patientVecnaId });
    }
    this._switchEregContent(this._staffPlaceholderAppointmentEditPerspectives[patientVecnaId]);
  },

  /**
   * Uses the already initialized staff select workflow perspective and renders it.
   *
   * @method _staffSelectWorkflow
   * @param patientVecnaId {String} the Vecna id of the patient that the staff is ereging.
   * @param appointmentExternalId {String} the id of the appointment to configure the workflow for.
   * @private
   */
  _staffSelectWorkflow: function(patientVecnaId, appointmentExternalId) {
    if (!this._staffSelectWorkflowPerspectives[appointmentExternalId]) {
      this._staffSelectWorkflowPerspectives[appointmentExternalId] = new EregStaffSelectWorkflowPerspective({
        patientVecnaId: patientVecnaId,
        appointmentExternalId: appointmentExternalId
      });
    }
    this._switchEregContent(this._staffSelectWorkflowPerspectives[appointmentExternalId]);
  },

  /**
   * Uses the already initialized staff select workflow perspective and renders it.
   *
   * @method _multiAppointmentStaffSelectWorkflow
   * @param patientVecnaId {String} the Vecna id of the patient that the staff is ereging.
   * @param regDate {String} the date of the appointments to configure the workflow for.
   * @private
   */
  _multiAppointmentStaffSelectWorkflow: function(patientVecnaId, regDate) {
    if (!this._staffSelectWorkflowPerspectives[regDate]) {
      this._staffSelectWorkflowPerspectives[regDate] = new EregStaffSelectWorkflowPerspective({
        patientVecnaId: patientVecnaId,
        regDate: regDate
      });
    }
    this._switchEregContent(this._staffSelectWorkflowPerspectives[regDate]);
  },

  /**
   * Switches the content of the e-reg perspective.
   * @param contentView {Torso.View} that the e-reg perspective should display.
   * @private
   */
  _switchEregContent: function(contentView) {
    this._eregApp.setContentView(contentView);
    var disposePerspective = false;
    this._switchPerspectives(this._eregApp, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, patientNavView.TOP_LEVEL_NAV_ITEMS.NO_CURRENT, disposePerspective);
    document.title = $.i18n.prop(contentView.moduleNamespace + '.title');
  },

  /**
   * Changes to the new perspective
   *
   * @method _switchPerspectives
   * @param newPerspective {Torso.View} the new perspective to switch to.
   * @param currentNavItem {String} identifies the nav item to highlight as the current item.
   * @param dispose {Boolean} whether to call dispose when the newPerspective is closed.
   * @private
   */
  _switchPerspectives: function(newPerspective, currentNavItem, currentDropdownItemParent, dispose) {
    patientNavView.setCurrentNavItem(currentNavItem);
    patientNavView.setCurrentDropdownItemParent(currentDropdownItemParent);
    if (newPerspective === this._perspective) {
      return;
    }
    this._closePerspective();

    if(!newPerspective) {
      return;
    }

    this._perspective = newPerspective;
    this._disposePerspective = dispose;
    document.title = $.i18n.prop(this._perspective.moduleNamespace + '.title');
    var body = $('body');
    if (launcherAppInterface.isAtHospital()) {
      body.removeClass('at-home');
      body.addClass('at-hospital');
    } else {
      body.removeClass('at-hospital');
      body.addClass('at-home');
    }
    this._perspective.attachTo($('.app-container'));

    if (this._perspective instanceof AuthPerspective || this._perspective instanceof EregAuthBarcodePerspective || this._perspective instanceof EregAuthMethodConfigPerspective) {
      if (this._timeoutWidget) {
        this._timeoutWidget.stopAndClose();
      }
    } else {
      if (this._timeoutWidget) {
        this._timeoutWidget.resetWithParams(this._getTimeoutWidgetOptions());
      } else {
        this._setupTimeoutWidget();
      }
    }
  },

  /**
   * Close (detach or dispose) the current perspective.
   *
   * @method _closePerspective
   * @private
   */
  _closePerspective: function() {
    if (this._perspective) {
      if (this._disposePerspective) {
        this._perspective.dispose();
      } else {
        this._perspective.detach();
      }
    }
  }
}))();

portalMain.start();

module.exports = portalMain;
